import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Behavioral Solutions of Massachusetts theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const BHSOLOFMA_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/bhsolofma/logo.png",
        alt: "Behavioral Solutions of Massachusetts Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 21,
  state: "MA",
  departmentIds: [152, 237],
};
